import { ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, CartesianGrid } from "recharts";
import { Card } from "@/components/ui/card";

function TooltipBox({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  const d = payload[0].payload;
  return (
    <div className="rounded-md border border-slate-200 bg-white p-2.5 text-xs shadow-sm" data-testid="event-chart-tooltip">
      <p className="font-semibold text-slate-900 mb-1">{label}</p>
      <p className="text-slate-600">Visitors <b className="font-mono">{d.visitors}</b></p>
      <p className="text-slate-600">Leads <b className="font-mono">{d.leads}</b></p>
      <p className="text-slate-600">Converted <b className="font-mono">{d.converted}</b></p>
      <p className="text-indigo-700">Conversion <b className="font-mono">{d.rate}%</b> <span className="text-slate-400">(converted ÷ leads)</span></p>
    </div>
  );
}

export function EventComparisonChart({ events }) {
  if (!events?.length || events.length < 1) return null;
  const data = [...events].reverse().map((e) => ({
    name: e.event.length > 22 ? e.event.slice(0, 21) + "…" : e.event, full: e.event,
    visitors: e.visitors, leads: e.leads, converted: e.converted,
    rate: e.leads ? Math.round((e.converted / e.leads) * 100) : 0,
  }));
  return (
    <Card className="p-4 border-slate-200 overflow-hidden" data-testid="event-comparison-chart">
      <div className="flex items-baseline justify-between mb-2">
        <h3 className="font-heading font-semibold text-slate-900">Exhibition comparison</h3>
        <p className="text-[11px] text-slate-400">Bars: visitors, leads, converted · Line: conversion rate (converted ÷ leads)</p>
      </div>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={data} margin={{ top: 8, right: 8, left: -16, bottom: 0 }} barGap={2}>
            <CartesianGrid vertical={false} stroke="#e2e8f0" />
            <XAxis dataKey="name" tick={{ fontSize: 11, fill: "#64748b" }} interval={0} angle={data.length > 5 ? -20 : 0} textAnchor={data.length > 5 ? "end" : "middle"} height={data.length > 5 ? 56 : 30} />
            <YAxis yAxisId="n" allowDecimals={false} tick={{ fontSize: 11, fill: "#64748b" }} />
            <YAxis yAxisId="pct" orientation="right" domain={[0, 100]} tickFormatter={(v) => `${v}%`} tick={{ fontSize: 11, fill: "#4f46e5" }} />
            <Tooltip content={<TooltipBox />} cursor={{ fill: "#f1f5f9" }} />
            <Legend wrapperStyle={{ fontSize: 11 }} />
            <Bar yAxisId="n" dataKey="visitors" name="Visitors" fill="#94a3b8" radius={[3, 3, 0, 0]} maxBarSize={36} />
            <Bar yAxisId="n" dataKey="leads" name="Leads" fill="#0f172a" radius={[3, 3, 0, 0]} maxBarSize={36} />
            <Bar yAxisId="n" dataKey="converted" name="Converted" fill="#10b981" radius={[3, 3, 0, 0]} maxBarSize={36} />
            <Line yAxisId="pct" type="monotone" dataKey="rate" name="Conversion %" stroke="#4f46e5" strokeWidth={2} dot={{ r: 4, fill: "#4f46e5" }} activeDot={{ r: 5 }} />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
}
